// 挂牌申请
<template>
  <div class="container-main">
    <div class="top-title">挂牌申请</div>
    <div class="container">
      <ApplicationSteps :activeNumber="activeNumber" :titleArray="titleArray" />
      <div class="select-business" v-if="activeNumber == 1">
        <div class="top">
          <div class="image">
            <img src="../../../assets/icon-3.png" />
          </div>
          <div class="right-content">
            <div class="title">
              <span>农</span>
              <span>村</span>
              <span>产</span>
              <span>权</span>
              <span>交</span>
              <span>易</span>
            </div>
            <p>
              产权交易是资产拥有者将自己的资产权和经营权全部或部分转让的一种经济活动。
            </p>
          </div>
        </div>
        <div class="bottoms">
          <el-button class="button" @click="selectTheBusiness(1)">
            <div class="buton_column">
              <div class="p_1">农村土地</div>
            </div>
          </el-button>
          <el-button class="button" @click="selectTheBusiness(2)">
            <div class="buton_column">
              <div class="p_1">林权</div>
            </div>
          </el-button>
          <!-- <el-button class="button" @click="selectTheBusiness(3)">
            <div class="buton_column">
              <div class="p_1">涉农企业股权</div>
            </div>
          </el-button>
          <el-button class="button" @click="selectTheBusiness(4)">
            <div class="buton_column">
              <div class="p_1">实物资产</div>
            </div>
          </el-button>
          <el-button class="button" @click="selectTheBusiness(5)">
            <div class="buton_column">
              <div class="p_1">农业知识产权</div>
            </div>
          </el-button>
          <el-button class="button" @click="selectTheBusiness(6)">
            <div class="buton_column">
              <div class="p_1">农业经济事项</div>
            </div>
          </el-button> -->
          <el-button class="button" @click="selectTheBusiness(7)">
            <div class="buton_column">
              <div class="p_1">自定义</div>
            </div>
          </el-button>
        </div> 
      </div>
      <div v-if="activeNumber == 3">
        <img src="@/assets/examine.png" alt class="img_position" />
        <p class="p_position">已提交相关方审核，请耐心等候</p>
      </div>
    </div>
    <div class="btn" v-if="activeNumber == 3">
      <el-button class="sumbit" @click="$router.push({ name:'MyApplyList'})">查看我的挂牌</el-button>
      <el-button class="nextstep-button" @click="switchingSteps()">再申请一个</el-button>
    </div>
  </div>
</template>

<script>
import { getApplicantFarmersFiles } from '@/businessJs/roleNeedFiles.js' // 获取所需资料
import ApplicationSteps from '@/components/ApplicationSteps' // 步骤组件
export default {
  components: {
    ApplicationSteps,
  },
  data() {
    return {
      activeNumber: this.$route.query.activeNumber * 1 || 1,
      titleArray: ['选择业务类型', '录入标的信息', '确认挂牌'],
    }
  },
  watch: {
    '$route.query': (newVal,oldVal) => {
        if(newVal.activeNumber != oldVal.activeNumber){
          window.location.reload();
        }
      }
  },
  methods: {
    // 选择业务
    selectTheBusiness(type) {
      switch (type){
        case 1 :
          this.$router.push({ name: 'RuralLand'})
          break;
        case 2 :
          this.$router.push({ name: 'ForestRight'})
          break;
        case 3 :
          this.$message.warning("功能暂未开放");
           break;
        case 4 :
          this.$message.warning("功能暂未开放");
           break;
        case 5 :
          this.$message.warning("功能暂未开放");
           break;
        case 6 :
          this.$message.warning("功能暂未开放");
           break;
        case 7 :
           this.$router.push({ name: 'Custom'})
           break;
      }
    },
    switchingSteps(){
      this.$router.push({ name: 'PropertyListingApplication', query: {activeNumber:1}})
    },
  }
}
</script>

<style lang="scss" scoped>
.container-main {
  width: 1080px;
  margin: 50px auto 0;
  background: #fff;
  width: 1200px;
  padding: 30px;
  .container {
    width: 950px;
    margin: 0 auto;
    background: #fff;
  }
  .select-business {
    margin: 44px auto 31px;
    .top {
      background: #f8f9fb;
      padding: 70px 0;
      display: flex;
      justify-content: center;
      .image {
        width: 80px;
        height: 88px;
        margin-right: 46px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .right-content {
        width: 480px;
        .title {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(57, 66, 89, 1);
          line-height: 24px;
          letter-spacing: 20px;
          span {
            position: relative;
            &::after {
              content: '/';
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #60697e;
              position: absolute;
              right: -13px;
            }
            &:last-child {
              &::after {
                content: '';
              }
            }
          }
        }
        p {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(96, 105, 126, 1);
          line-height: 20px;
        }
      }
    }
    .bottoms {
      height: 145px;
      margin-top: 20px;
      margin-bottom: 180px;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      .button {
        width: 120px;
        height: 145px;
        border-radius: 6px;
        padding: 0 10px;
        .buton_column {
          display: flex;
          flex-direction: column;
          .p_1 {
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
            white-space: normal;
            line-height: initial;
          }
          .p_2 {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
          }
        }
      }
    }
  }
  .img_position {
    margin: auto;
    display: block;
    margin-top: 68px;
  }
  .p_position {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #394259;
    letter-spacing: 0;
    line-height: 14px;
    text-align: center;
    margin-bottom: 178px;
  }
  .btn{
    .nextstep-button {
      border: 1px solid #F1564D;
      border-radius: 2px;
      color: #F1564D;
      background: none;
    }
  }
}
</style>